export default __webpack_public_path__ + "HydrogenHoverPin.png";